/* eslint-disable no-use-before-define */
import { useState, useEffect } from 'react';
import { accountTypesMockChile } from '@constants/bankAccountType';

export const useAccountType = () => {
  const [accountTypes, setAccountTypes] = useState([]);

  useEffect(() => {
    setAccountTypes(accountTypesMockChile);
  }, []);

  return {
    accountTypes,
  };
};
